import React from 'react';

import { useShowShimmerAction } from '../../../components/context/full-freeshipping';
import Circle from './components/circle-skeleton';
import Line from './components/line-skeleton';

const namespace = 'ui-search-fullsnackbar-skeleton';

/**
 * Skeleton component for shipping information loading state
 * @component
 * @returns {JSX.Element} Rendered skeleton component
 */

const FullShippingInfoSkeleton = () => {
  const showShimmerAction = useShowShimmerAction();

  return (
    <div className={`${namespace}__header`}>
      <div className={`${namespace}__icon-line-container`}>
        <div className={`${namespace}__icon-container`}>
          <Circle />
        </div>
        <div className={`${namespace}__line-container`}>
          <Line />
          <Line size="small" />
          <Line />
        </div>
      </div>
      <div className={`${namespace}__line-button-container`}>
        {showShimmerAction && <Line size="extra-large" className={`${namespace}__line-button`} />}
      </div>
    </div>
  );
};

export default FullShippingInfoSkeleton;
